module.exports = __webpack_public_path__ + "static/media/mobileicon.7fa2de86.svg";